import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
  ICurrencyInitialState,
  ISetCurrencyListPayload
} from "./currencyReducerTypes";

const currencyInitialState: ICurrencyInitialState = {
  currencies: [],
  isLoading: false,
  errorMessage: '',
};

const currencySlice = createSlice({
  name: 'currency',
  initialState: currencyInitialState,
  reducers: {
    getCurrencyList(state) {
      state.isLoading = true;
      state.errorMessage = '';
    },
    setCurrencyList(state, {payload}: PayloadAction<ISetCurrencyListPayload>) {
      state.currencies = payload.currencies;
      state.isLoading = false;
      state.errorMessage = '';
    },
    setCurrencyListError(state, {payload}: PayloadAction<{errorMessage: string}>) {
      state.isLoading = false;
      state.errorMessage = payload.errorMessage;
    },
  },
});

export const {
  getCurrencyList,
  setCurrencyList,
  setCurrencyListError,
} = currencySlice.actions;

export default currencySlice.reducer;
